import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = { class: "video-container" }
const _hoisted_3 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "modal",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-content", { 'loading': _ctx.isLoading }])
        }, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            class: "close-button",
            "aria-label": "Закрыть"
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
              }),
              _createElementVNode("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
              })
            ], -1)
          ])),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "spinner" }, null, -1)
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.videoId)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 0,
                  ref: "videoIframe",
                  src: _ctx.videoSrc,
                  title: `YouTube видео ${_ctx.videoId}`,
                  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                  allowfullscreen: "",
                  onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onIframeLoad && _ctx.onIframeLoad(...args)))
                }, null, 40, _hoisted_3))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ])
    ]),
    _: 1
  }))
}